"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _LayerRenderer2 = _interopRequireDefault(require("./LayerRenderer"));

var _ImageCreativeLayer = _interopRequireDefault(require("../../models/creative/ImageCreativeLayer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ImageRenderer = /*#__PURE__*/function (_LayerRenderer) {
  (0, _inherits2["default"])(ImageRenderer, _LayerRenderer);

  var _super = _createSuper(ImageRenderer);

  function ImageRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor) {
    (0, _classCallCheck2["default"])(this, ImageRenderer);

    if (!_ImageCreativeLayer["default"].isImageCreativeLayer(creativeLayer)) {
      throw new Error('Incompatible creative layer. Requires creative layer to be of content type IMAGE');
    }

    return _super.call(this, creativeLayer, contentStore, layerTransformer, filterProcessor);
  }

  return ImageRenderer;
}(_LayerRenderer2["default"]);

exports["default"] = ImageRenderer;